import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Session } from '../../../../core/models/chat.models';
import { SidebarAccountComponent } from '../sidebar-account/sidebar-account.component';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, SidebarAccountComponent],
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent {

  @Input() sessions: Session[] = [];
  @Input() currentId: string | null = null;
  @Input() openMenuId: string | null = null;

  @Output() newSession = new EventEmitter<void>();
  @Output() onSessionSelected = new EventEmitter<Session>();
  @Output() onDeleteSession = new EventEmitter<Session>();
  @Output() toggleMenu = new EventEmitter<string>();

  onToggleMenu(event: Event, id: string): void {
    event.stopPropagation();
    this.toggleMenu.emit(id);
  }

  onDeleteClick(event: Event, session: Session): void {
    event.stopPropagation();
    this.onDeleteSession.emit(session);
  }
}
